import {IProtocolStepKind} from "../../../types/protocol";
import {Text, TextProps} from "@mantine/core";
import {forwardRef} from "react";


interface StepKindDisplayFieldProps extends TextProps {
    kind: IProtocolStepKind
};

function getStepKindDisplayString(kind: IProtocolStepKind) {

    switch (kind) {
        case IProtocolStepKind.Q_AND_A:
            return "Q&A"
        case IProtocolStepKind.QUESTIONNAIRE:
            return "Questionnaire"
        case IProtocolStepKind.MEG_SCAN:
            return "MEG"
        case IProtocolStepKind.REST_EVENT:
            return "Rest"
        case IProtocolStepKind.NOTE:
            return "Note"
        case IProtocolStepKind.EEG_SCAN:
            return "EEG"
        case IProtocolStepKind.ECG_SCAN:
            return "ECG"
        case IProtocolStepKind.MEASURE_HR:
            return "Heart Rate"
        case IProtocolStepKind.MEASURE_BP:
            return "Blood Pressure"
        case IProtocolStepKind.MEASURE_PLR:
            return "Pupillometry"
        case IProtocolStepKind.STIM_EVENT:
            return "Stimulation Treatment"
        case IProtocolStepKind.START_DATA_COLLECTION:
            return "Start Data Collection"
        case IProtocolStepKind.STOP_DATA_COLLECTION:
            return "Stop Data Collection"
        case IProtocolStepKind.GROUP:
            return "Group"
        case IProtocolStepKind.INSTRUCTIONS:
            return "Instructions"
        case IProtocolStepKind.VAS_PAIN_SCORE:
            return "VAS Pain Score"
        case IProtocolStepKind.NRS_PAIN_SCORE:
            return "NRS Pain Score"
        case IProtocolStepKind.PP_RELIEF:
            return "PP Relief"
        case IProtocolStepKind.PORT_CONFIG:
            return "Port Configuration"
        default:
            // this is here to cause a compiler error if we don"t handle all
            // step types
            assertNever(kind)
    }
}

// Helper function for exhaustive type checking
function assertNever(value: never): never {
    throw new Error(`Unhandled step kind: ${value}`);
}

export const StepKindDisplayField = forwardRef<HTMLDivElement, StepKindDisplayFieldProps>(({kind, ...others}, ref) => {
        return (
            <Text ref={ref} ta="center" {...others}>{getStepKindDisplayString(kind)}</Text>
        )
    }
)